'use es6';

import { Record, List } from 'immutable';
export default Record({
  accountName: null,
  accountType: null,
  domain: null,
  id: 0,
  numberOfUsers: 0,
  numberOfContacts: 0,
  obscured: false,
  products: List(),
  cookieWeight: 0,
  disabled: false,
  appDomain: null
}, 'Account');